import { defineElement, html, TemplateElement, when } from '@webtides/element-js';
import '../../../../src/components/@e-banking/components/e-banking-slider-item/e-banking-slider-item.js';

class EditableSliderItem extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }

    injectProperties() {
        return { mgnlContext: null };
    }

    template() {
        return html`
            ${when(
                !this.mgnlContext?.isMagnoliaEdit,
                html`
                    <mb-e-banking-slider-item>
                        <mgnl-editable-area .content="${this.content?.contentElements}"></mgnl-editable-area>
                    </mb-e-banking-slider-item>
                `,
                html` <mgnl-editable-area
                    class="block my-16"
                    .content="${this.content?.contentElements}"
                ></mgnl-editable-area>`,
            )}
        `;
    }
}

defineElement('editable-slider-item', EditableSliderItem);
